import React from 'react'
import { currencyFormat } from '../../../../../../../utils/DataFormatUtils'
import getSymbolFromCurrency from 'currency-symbol-map'
export const PriceColumnFormatter = (cellContent, row) => (
  <>
    {getSymbolFromCurrency(row.currencyCode)}
    {currencyFormat(cellContent)}
  </>
)
